// Ten frames: boxes in 2 rows of 5, with counters filled in order. Plain
// React SVG, like practice-count.tsx. Nothing is numbered. The second kind
// of counter (for adding on) is a ring with a dot in the middle, not just a
// second colour, so the two kinds are told apart without colour.

import {
  describeTenFrame,
  tenFramePicture,
  type TenFrameSpec,
} from './practice-ten-frame-data';

const INK = '#2d4a3e';
const FIRST_FILL = '#7b5ea7';
const ADDED_FILL = '#fbe3cf';
const ADDED_RING = '#d9792b';

export function TenFrameView({ frame }: { frame: TenFrameSpec }) {
  const picture = tenFramePicture(frame);
  const { box, radius } = picture;
  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeTenFrame(frame)}
        viewBox={`0 0 ${String(picture.width)} ${String(picture.height)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(picture.width * 1.3))}px` }}
      >
        {picture.frames.map((one, at) => (
          <g key={at} data-frame={at + 1}>
            {one.boxes.map((place, index) => (
              <rect
                key={index}
                data-box="true"
                x={place.x}
                y={place.y}
                width={box}
                height={box}
                fill="#ffffff"
                stroke={INK}
                strokeWidth="1.5"
              />
            ))}
            {/* A thicker outline round the whole frame, so two frames are
                never read as one long one. */}
            <rect
              x={one.x}
              y={one.y}
              width={box * 5}
              height={box * 2}
              fill="none"
              stroke={INK}
              strokeWidth="3"
            />
            {one.counters.map((counter, index) =>
              counter.kind === 'first' ? (
                <circle
                  key={index}
                  data-counter="first"
                  cx={counter.cx}
                  cy={counter.cy}
                  r={radius}
                  fill={FIRST_FILL}
                  stroke={INK}
                  strokeWidth="1.5"
                />
              ) : (
                <g key={index} data-counter="added">
                  <circle
                    cx={counter.cx}
                    cy={counter.cy}
                    r={radius - 2}
                    fill={ADDED_FILL}
                    stroke={ADDED_RING}
                    strokeWidth="4"
                  />
                  <circle
                    cx={counter.cx}
                    cy={counter.cy}
                    r={radius * 0.28}
                    fill={INK}
                  />
                </g>
              ),
            )}
          </g>
        ))}
      </svg>
    </figure>
  );
}
